import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken } from './auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000
})

service.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers['token'] = token
  }
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type']
  }
  return config
}, error => Promise.reject(error))

service.interceptors.response.use(
  response => {
    // blob 类型直接返回原始 response（下载等场景）
    if (response.config.responseType === 'blob' || response.data instanceof Blob) {
      return response
    }
    const res = response.data
    if (res.code === 401) {
      removeToken()
      location.reload()
      return Promise.reject(new Error(res.msg || '未授权'))
    }
    if (res.code !== 200) {
      Message.error({ message: res.msg || '请求失败', duration: 3000, showClose: true })
      return Promise.reject(new Error(res.msg))
    }
    return res
  },
  error => {
    const msg = error.response?.data?.msg || error.message || '网络错误'
    Message.error({ message: msg, duration: 3000, showClose: true })
    return Promise.reject(error)
  }
)

export default service
